import classNames from 'classnames';
import type React from 'react';
import type { Size } from '../../constants';

type GapSize = Size;

const gapSizeToClassname: Record<GapSize, string> = {
  sm: 'gap-2',
  md: 'gap-2.5',
  lg: 'gap-3',
  xl: 'gap-4',
  '2xl': 'gap-5',
  '3xl': 'gap-6',
  '4xl': 'gap-7',
};

export interface GridProps<T> {
  onItemClick?: (data: T) => void;
  data: T[];
  keyName?: string;
  renderItem: (
    itemData: T,
    selected: string | number | null,
    onClick?: (data: T) => void
  ) => React.ReactNode;
  selected?: string | number | null;
  actionItem?: React.ReactNode;
  cols?: number;
  gap?: GapSize;
  testDsId?: string;
}

export const Grid = <T extends Record<string, any>>({
  keyName = 'id',
  data,
  onItemClick,
  renderItem,
  selected = null,
  actionItem,
  cols = 4,
  gap = 'md',
  testDsId = '',
}: GridProps<T>) => {
  return (
    <div
      style={{
        gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))`,
      }}
      className={classNames('w-full grid', gapSizeToClassname[gap])}
    >
      {actionItem}
      {data?.map((itemData: T, index) => {
        return (
          <div
            key={itemData[keyName]}
            data-ds-id={`${testDsId}grid-tile-${index}`}
          >
            {renderItem(itemData, selected, onItemClick)}
          </div>
        );
      })}
    </div>
  );
};
